/**
 * used on the frontpage
 * showing the recent viewed profiles
 * we want 1 line of recent profiles. so when you resize the screen, the line will be bigger or smaller
 * @type {String}
 */
define('components/decorators/recent',[
    'jquery'
], function($) {
    $.extend(companyInfo.decorators, {

        'recent': function(e) {
          var component = $(this);
          var profiles = component.find('a[data-profile]');
          var startLine = component.find('#start-line');
          var moreButton = component.find('#more');

          $(window).resize(showProfiles);
          $(moreButton).click(toggleMore);

          /**
           * show the line of profiles
           */
          function showProfiles(e) {
            var componentWidth = component.width();
            var moreButtonWidth = $(moreButton).outerWidth(true);
            var startLineWidth = $(startLine).outerWidth(true);
            componentWidth = componentWidth - moreButtonWidth - startLineWidth - 20;

            var currentWidth = 0;
            var firstHidden = false; //to check for extra function on the first profile to be hidden
            for(var i=0; i<profiles.length; i++){
              var profile = $(profiles[i]);

              //when a profile is resized and truncated, please show the full name again.
              //this is saved after truncate
              if(profile.data('full-text')){
                profile.text(profile.data('full-text'));
              }

              currentWidth += profile.outerWidth(true);
              if(currentWidth > componentWidth){
                if(!firstHidden){
                  //if this is the first profile that does not fit on the line,
                  //check if it's a long name. if long than truncate the name so that it does fit
                  if(resizeName(profile, currentWidth-profile.outerWidth(true), componentWidth)){
                    profile.show();
                    continue;
                  }
                  firstHidden = true;
                }
                profile.hide();
                continue;
              }
              profile.show();
            }


            //if all profiles are shown, do not show the "show more" button
            toggleText(moreButton);
            if(profiles.filter(':hidden').length === 0){
              moreButton.hide();
            }
          }

          //toggle the more button, showing all the profiles
          function toggleMore() {

            //check if there are profiles hidden or not
            if(!profiles.last().is(":visible")){
              profiles.each(function(){
                if($(this).data('full-text')){
                  $(this).text($(this).data('full-text'));
                }
                $(this).show();
              });
              toggleText(moreButton);
            }else{
              toggleText(moreButton);
              showProfiles();
            }


          }

          function resizeName(profile, currentWidth, maxWidth) {
            var text = profile.text();
            profile.attr("data-full-text", text);
            for(var i=0; i<text.length; i++){
              var tempText = text.substr(0, text.length-i);
              profile.text(tempText + '...');
              if(currentWidth + profile.outerWidth(true) < maxWidth && tempText.length > 20){
                return true;
              }
            }

            profile.text(text);
            return false;
          }


          function toggleText(el) {
            if(profiles.filter(':hidden').length === 0){
              el.text(el.data('toggle-text-less'));
            }else{
              el.text(el.data('toggle-text-more'));
            }
          }


          showProfiles();
        }
    });
});

